import { CSSProperties, FC, ReactNode } from 'react';
import { Box, Button, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProps {
  Icon: FC;
  title: string;
  description: string | ReactNode;
  width?: number | string;
  buttonText?: string;
  onButtonClick?: () => void;
  descriptionStyle?: CSSProperties;
  style?: CSSProperties;
}

export const EmptyScreen = ({
  Icon,
  title,
  description,
  width = 405,
  buttonText,
  onButtonClick,
  descriptionStyle = {},
  style = {},
}: IProps) => (
  <Column align="center">
    <Box
      style={{
        marginTop: 60,
        marginBottom: 28,
        ...style,
      }}
    >
      <Icon />
    </Box>
    <Column gap={2} style={{ width }}>
      <Typography as="span" size="heading_4" bold color={colors.neutral[500]} textAlign="center">
        {title}
      </Typography>
      <Typography as="span" color={colors.neutral[500]} textAlign="center" style={descriptionStyle}>
        {description}
      </Typography>
    </Column>
    {buttonText && onButtonClick && (
      <Button onClick={onButtonClick} size="lg" style={{ marginTop: 60 }}>
        {buttonText}
      </Button>
    )}
  </Column>
);
